module.exports = "/images/input_check_mark.png?8048ebdf30009145baa9ca2a9c535fc8";